import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserContext } from "./context/UserContext";

function AuthRoute({ children }) {
  const { isLogged } = useContext(UserContext);
  const location = useLocation();

  if (isLogged)
    return (
      <Navigate
        replace
        to={{
          pathname: location.state?.from ? location.state.from : "/jobs",
        }}
      />
    );
  return children;
}

export default AuthRoute;
